import { useAppStore } from '@stores/app';

export function waitForAwsWafIntegration() {
	const appStore = useAppStore();

	return new Promise((resolve, reject) => {
		if (!appStore.wafIsLoaded) {
			const maxAttempts = 40; // Maximum number of attempts
			const interval = 100; // Interval in milliseconds between attempts
			let attempts = 0;

			const checkAwsWafIntegration = () => {
				attempts++;
				if (window.AwsWafIntegration) {
					appStore.wafIsLoaded = true;
					resolve(true);
				} else if (attempts >= maxAttempts) {
					appStore.wafIsLoaded = false;
					reject(new Error('AWS WAF Integration is not available.'));
				} else {
					setTimeout(checkAwsWafIntegration, interval);
				}
			};

			checkAwsWafIntegration();
		} else {
			resolve(true);
		}
	});
}

export function getWafToken() {
	return waitForAwsWafIntegration().then(() => {
		return window.AwsWafIntegration.getToken();
	});
}
